/**
 * Return the <form> element which contains the specified element
 */

export function findParentForm(elm) {
    if (elm == null)
        return null;
    if (elm.tagName == 'FORM')
        return elm;
    else
        return findParentForm(elm.parentNode);
}

/*convenience call*/
export function appendFormOnSubmitHandler(aFunction, formRef) {
    addFormOnSubmitHandler(aFunction, formRef, false);
}

/*convenience call*/
export function prependFormOnSubmitHandler(aFunction, formRef) {
    addFormOnSubmitHandler(aFunction, formRef, true);
}

export function doHookedFormSubmit() {
    //call all hooks
    for (let i = 0; i < this.onSubmitHooks.length; i++) {
        //abort the submission if the hook function returns false or null.
        //if the result is undefined, continue with the submission because it
        //means the function simply didn't return a value (and thus doesn't care)
        const result = this.onSubmitHooks[i]();
        if (typeof (result) != 'undefined' && !result)
            return false;
    }

    //all hooks returned true - continue with the submission.
    return true;
}

/**add a function to be called when a form is submitted.  If the form already
 has an onsubmit function then the new function will be called
 before or after the existing (depending 'prepend' parameter).

 If the given function returns false or null the submission process will be aborted.
 */
function addFormOnSubmitHandler(aFunction, formRef, prepend) {
    //does form have onsubmit handler yet?
    if (formRef.onsubmit) {
        //add the hooks array to the form object if necessary
        if (!formRef.onSubmitHooks) {
            //first handler will be the current onsubmit function

            //the original onsubmit function must remain as a member of the form object
            // so that references to 'this' are evaluated correctly.
            formRef.orig_onsubmit = formRef.onsubmit;
            formRef.onSubmitHooks = [function () {
                return formRef.orig_onsubmit();
            }];

            //new onsubmit is our helper function
            formRef.onsubmit = doHookedFormSubmit;
        }

        if (prepend) {
            //tack on another function to the FRONT of the array
            formRef.onSubmitHooks.unshift(aFunction);
        } else {
            //tack on another function to the BACK of the array
            formRef.onSubmitHooks.push(aFunction);
        }
    }
    //else this is the first one so just call it directly (less overhead)
    else {
        formRef.onsubmit = aFunction;
    }
}



/*submit the given form with an extra query parameter.  If the form
 has an onsubmit handler it will be called.  The return value of the submit handler
 will be ignored.
	Note: this does not work for method="GET" forms, only POST.
*/
export function submitWithExtraParam(theForm, param) {
    //add the CANCEL parameter
    if (theForm.action.indexOf('?') == -1)
        theForm.action += '?' + param;
    else
        theForm.action += '&' + param;

    //if the form has an onsubmit handler call it
    if(theForm.onsubmit)
        theForm.onsubmit();

    //submit the form (even if the onsubmit handler said not to (because we're canceling!))
    theForm.submit();
}

/*enable all form inputs within the specified form.*/
export function enableAllInputs(formRef) {
    _enableInputList(document.getElementsByTagName("input"), formRef);
    _enableInputList(document.getElementsByTagName("select"), formRef);
    _enableInputList(document.getElementsByTagName("textarea"), formRef);
    return true;
}

function _enableInputList(inputs, formRef) {
    for (let i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (input.disabled && input.form === formRef) {
            //leave buttons alone (they do not contribute to the form input)
            //(This exclusion is necessary because our form buttons disable themselves upon click
            // so they need to be left alone)
            if (!input.type || (input.type != 'submit' && input.type != 'button')) {
                input.disabled = false;
            }
        }
    }
}

export function caw_onChangeListener(frm) {
    if (!frm) {
        console.error("caw_onChangeListener failed because form is undefined...");
        return;
    }

    if (frm.btnSave) {
        frm.btnSave.style.display="inline";
    }

    // some forms start with a different label on the button such as "Close"
    if (frm.CANCEL)
        frm.CANCEL.value = i18n.common.cancel;

    //if there's a menu to do "Other Actions" then we should disable it too
    const moreBtn = document.getElementById('more_btn');
    if (moreBtn) {
        moreBtn.className = 'btn disabled';

        //disable the link
        moreBtn.onclick = null;
        if (moreBtn.href)
            moreBtn.href = '#';
    }

    // Returning true turns off this listener.
    // It ran once. It has done its job.
    return true;
}